import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './../../store';
import { Notification, removeNotification } from './../../store/slice/notificationsSlice';
import { useSnackbar } from 'notistack';

const SnackbarContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const notifications = useSelector((state: RootState) => state.notifications.notifications);
  const displayed = useRef<string[]>([]);
  useEffect(() => {
    notifications.forEach((notif: Notification) => {
      // If we've already displayed this notification, skip it.
      if (displayed.current.includes(notif.id)) return;

      const message = typeof notif.message === 'string' ? notif.message.trim() : '';
      if (!message) {
        dispatch(removeNotification(notif.id));
        return;
      }

      // Enqueue the notification using notistack
      enqueueSnackbar(message, {
        variant: (notif.type === 'warn' ? 'warning' : notif.type) as any,
        autoHideDuration: 2000,
        // content: (key: any, message: any) => (
        //   <SnackbarContent
        //     key={key}

        //     data-qa={`snackbar-${notif.type}`}
        //   >{message}</SnackbarContent>
        // ),
        onClose: () => {
          // Optionally, dispatch removal on close.
          dispatch(removeNotification(notif.id));
          // Remove from displayed notifications
          displayed.current = displayed.current.filter(id => id !== notif.id);
        },
        // You could also use onExited if you prefer:
        onExited: () => {
          dispatch(removeNotification(notif.id));
          displayed.current = displayed.current.filter(id => id !== notif.id);
        }
      });

      // Mark the notification as displayed
      displayed.current.push(notif.id);
    });
  }, [notifications, enqueueSnackbar, dispatch]);

  return null;
};

export default SnackbarContainer;
